// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29JJ4","colBig":"styles_colBig__-tI1V","colSmall":"styles_colSmall__2MY-6","shopifyNameWrapper":"styles_shopifyNameWrapper__23lKr"};